import {
  IonPage,
  IonToolbar,
  IonTitle,
  IonContent,
  IonButtons,
  IonBackButton,
} from '@ionic/react';
import { useLocation } from 'react-router-dom';
import { AppSectionHeader } from '../../components/ui/AppSectionHeader';
import { ChannelSearchContent } from './components/ChannelSearchContent';

// Dedicated channel search screen. Reached from the channels sub-bar box (the
// user types a term and presses Enter). The carried term arrives in the `q`
// query-string param and pre-fills the searchbar.
export const ChannelSearchPage = () => {
  const location = useLocation();
  const initialTerm = new URLSearchParams(location.search).get('q') ?? '';

  return (
    <IonPage>
      <AppSectionHeader variant="main">
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/app/main/channels" />
          </IonButtons>
          <IonTitle className="ml-4">Buscar canal</IonTitle>
        </IonToolbar>
      </AppSectionHeader>
      <IonContent className="ion-padding">
        <ChannelSearchContent initialTerm={initialTerm} />
      </IonContent>
    </IonPage>
  );
};
